import { useState, useEffect, useContext, Fragment, useMemo } from "react";

import Folder from "components/folder/folder.component";
import Table from "components/table/table.component";
import SidebarFolder from "components/sidebar/sidebar-folder/sidebar-folder.component";
import Selector from "components/selector/selector.component";

import { FolderContext } from "src/contexts/folder.context";

import useTranslate from "src/hooks/use-translate";

import "./archive.style.scss";
import { AuthContext } from "src/contexts/auth.context";
import { ARCHIVE_PERIODS } from "utils/lists.utils";

const List = ["2019", "2020", "2021", "2022"];

const Archive = () => {
	const { currentLocation, files, focusedFiles, goBack, addFolder } = useContext(FolderContext);
	const {
		user: { archivePeriod },
	} = useContext(AuthContext);
	const archivePeriodName = useMemo(() => ARCHIVE_PERIODS[archivePeriod], [archivePeriod]);

	const [breadcrumbs, setBreadcrumbs] = useState("");

	const t = useTranslate("Archive");

	useEffect(() => {
		const str = currentLocation.join(" > ");
		setBreadcrumbs(str.toUpperCase());
	}, [currentLocation]);

	const handleGoBack = () => {
		goBack();
	};

	const handleCreateFolder = () => {
		addFolder("New Folder", true);
	};

	const handleSelect = (value) => {
		console.log(value);
	};

	return (
		<div className="home-container">
			<div className="left-panel" style={{ paddingLeft: 0 }}>
				<div className="header-container">
					<h1 className="bold with-line">{t("archive")}</h1>
				</div>
				<div className="sidebar-folders-container padding-xl--inline">
					<Selector data={List} onSelected={handleSelect} />
				</div>
				<div className="red text-center size400 w600 padding-m--inline padding-s--block border border--thick smooth-corners margin-xs--top margin-l--bottom">
					{archivePeriodName} Archive Period
				</div>
				<div className="sidebar-folders-container scroll-bar scroll-bar--overflow">
					{Object.keys(files).map((folderName, index) => {
						const childrenFolders = files[folderName]?.files;
						const isEmpty = Object.keys(childrenFolders ?? {})?.length === 0;
						return (
							<div key={index} className="size300">
								<SidebarFolder
									key={folderName}
									folderName={folderName}
									label={t(folderName.toLowerCase())}
									isEmpty={isEmpty}
								/>
							</div>
						);
					})}
				</div>
				<div className="create-folder-button" onClick={handleCreateFolder}>
					+ {t("create folder")}
				</div>
			</div>
			<div className="right-panel">
				{currentLocation.length > 0 && (
					<Fragment>
						{breadcrumbs !== "" && (
							<div className="home-header">
								<ion-icon onClick={handleGoBack} name="arrow-back-outline" />
								<div className="breadcrumbs">{breadcrumbs}</div>
							</div>
						)}
						<div className="folders-container flex flex--start-items flex--wrap gap-l scroll-bar scroll-bar--overflow padding-m--right margin-m--right">
							<Folder addButton />
							{focusedFiles.folders.map(({ fileName, isEmpty, folderId }, index) => {
								return (
									<Folder
										key={fileName}
										fileName={fileName}
										isEmpty={isEmpty}
										folderId={folderId}
									/>
								);
							})}
						</div>
						<Table />
					</Fragment>
				)}
			</div>
		</div>
	);
};
export default Archive;
